import { Controller, ControllerProps } from "react-hook-form";
import YearInput, { YearInputProps } from "./YearInput";

type YearFormInputProps<T> = Omit<ControllerProps<T>, "render"> & {
  input: YearInputProps;
};

const YearFormInput = <T,>({
  name,
  rules,
  control,
  input,
  ...rest
}: YearFormInputProps<T>) => {
  return (
    <Controller
      {...rest}
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        const { value, ...fieldRest } = field;
        return (
          <YearInput
            {...fieldRest}
            {...input}
            value={value ? new Date(value) : undefined}
          />
        );
      }}
    />
  );
};

export default YearFormInput;